export default __webpack_public_path__ + "static/media/SEAT.ece6d5b0.jpeg";